import { BankAccountType, AchAccountOwnershipType } from "#graphql/supergraphEnums";
import { PaymentMethod } from "../../../../common/enums";
import { redactAccountNumber } from "../../../../common/utils";
import { type DetailedAchPaymentPrefObjectType } from "../../common/types";
import { RoutingNumberInputFields } from "../BankValidators/RoutingNumberInput/constants";
import {
  AchPaymentPrefInputFields,
  type AchPaymentPrefInputType,
  NO_SELECTION,
} from "./constants";

export const mapFormStateToContextState = (
  values: AchPaymentPrefInputType,
): DetailedAchPaymentPrefObjectType => {
  const accountOwnership = Object.values<string>(AchAccountOwnershipType).includes(
    values[AchPaymentPrefInputFields.OwnershipType],
  )
    ? (values[AchPaymentPrefInputFields.OwnershipType] as AchAccountOwnershipType)
    : null;
  const accountType = Object.values<string>(BankAccountType).includes(
    values[AchPaymentPrefInputFields.AccountType],
  )
    ? (values[AchPaymentPrefInputFields.AccountType] as BankAccountType)
    : null;
  return {
    __typename: "AchPaymentPrefObjectType",
    id: null,
    bankName: values[RoutingNumberInputFields.BankName]?.trim() || null,
    accountName: values[AchPaymentPrefInputFields.AccountHolderName]?.trim() || null,
    accountNumber: values[AchPaymentPrefInputFields.AccountNumber]?.trim() || null,
    accountOwnership,
    accountType,
    additionalInstructions:
      values[AchPaymentPrefInputFields.AdditionalInstructions]?.trim() || null,
    routingNumber: values[RoutingNumberInputFields.RoutingNumber]?.trim(),
    accountHolderType: "natural_person",
    bankInfoRedacted: `${
      values[RoutingNumberInputFields.BankName] ?? "Bank"
    } account ending in -${
      values?.accountNumber ? redactAccountNumber(values?.accountNumber) : ""
    }`,
    naturalPersonDateOfBirth: null,
    naturalPersonEmailAddress: null,
    naturalPersonFirstName: null,
    naturalPersonLastName: null,
    naturalPersonMiddleName: null,
    paymentMethod: PaymentMethod.ACH,
    paymentPrefId: null,
    signatureFullName: null,
  };
};

export const mapContextStateToFormState = (
  input?: DetailedAchPaymentPrefObjectType,
): AchPaymentPrefInputType => {
  return {
    [RoutingNumberInputFields.BankName]: input?.bankName ?? "",
    [AchPaymentPrefInputFields.AccountHolderName]: input?.accountName ?? "",
    [AchPaymentPrefInputFields.AccountNumber]: input?.accountNumber ?? "",
    [AchPaymentPrefInputFields.ConfirmAccountNumber]: input?.accountNumber ?? "",
    [RoutingNumberInputFields.RoutingNumber]: input?.routingNumber ?? "",
    [AchPaymentPrefInputFields.AccountType]:
      (input?.accountType as BankAccountType) ?? NO_SELECTION,
    [AchPaymentPrefInputFields.OwnershipType]:
      (input?.accountOwnership as AchAccountOwnershipType) ?? NO_SELECTION,
    [AchPaymentPrefInputFields.AdditionalInstructions]: input?.additionalInstructions ?? "",
  };
};
